import { SxProps, Theme } from '@mui/system';

const styles: Record<string, SxProps<Theme>> = {
  box: {
    width: '100%',
  },
  chipButton: {
    backgroundColor: 'white',
    borderRadius: 1,
    color: 'primary.main',
  },
  rating: {
    alignSelf: 'center',
  },
  sourcescrubButton: {
    alignSelf: 'flex-start',
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
};

export default styles;
